export const WaitFor = (ms) => new Promise((res) => setTimeout(res, ms));
export const NoOp = () => {};